export const MAIN_ADMINISTRATOR = "MAIN_ADMINISTRATOR";
export const CLIENT_ADMINISTRATOR = "CLIENT_ADMINISTRATOR";
export const END_USER = "END_USER";
